import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "pagination"
};
const _hoisted_2 = { class: "pagination-box" };
const _hoisted_3 = ["disabled"];
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--arrow-left-line" }, null, -1);
const _hoisted_5 = [
    _hoisted_4
];
const _hoisted_6 = ["onClick", "title"];
const _hoisted_7 = ["title"];
const _hoisted_8 = ["disabled"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--arrow-right-line" }, null, -1);
const _hoisted_10 = [
    _hoisted_9
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.totalPages > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("ul", _hoisted_2, [
                _createElementVNode("li", {
                    class: _normalizeClass(["prev", { 'disabled': _ctx.noPrevious() }])
                }, [
                    _createElementVNode("button", {
                        disabled: _ctx.noPrevious(),
                        type: "button",
                        class: "btn-green-light btn--icon btn--outline",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.page(_ctx.pageIndex - 1)))
                    }, _hoisted_5, 8, _hoisted_3)
                ], 2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (!_ctx.active(index))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.inRange(index))
                                    ? (_openBlock(), _createElementBlock("li", {
                                        class: "other",
                                        key: index
                                    }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            onClick: ($event) => (_ctx.page(index)),
                                            title: `${_ctx.__('Przejdź do strony')}: ${index}`
                                        }, _toDisplayString(index), 9, _hoisted_6)
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_ctx.inRange(index))
                                    ? (_openBlock(), _createElementBlock("li", {
                                        class: "current",
                                        key: index
                                    }, [
                                        _createElementVNode("span", {
                                            title: `${_ctx.__('Strona')} ${index}`
                                        }, _toDisplayString(index), 9, _hoisted_7)
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 64))
                    ], 64));
                }), 256)),
                _createElementVNode("li", {
                    class: _normalizeClass(["next", { 'disabled': _ctx.noNext() }])
                }, [
                    _createElementVNode("button", {
                        disabled: _ctx.noNext(),
                        type: "button",
                        class: "btn-green-light btn--icon btn--outline",
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.page(_ctx.pageIndex + 1)))
                    }, _hoisted_10, 8, _hoisted_8)
                ], 2)
            ])
        ]))
        : _createCommentVNode("", true);
}
